import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles, LinearProgress } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  linearProgress: {
    height: 0,
    transition: theme.transitions.create(['height']),
  },
  linearProgressShow: {
    height: theme.spacing(0.5),
  },
}));

const MyLinearProgress = ({ isLoading, 'data-testid': dataTestId }) => {
  const classes = useStyles();
  return (
    <LinearProgress
      data-testid={dataTestId}
      className={clsx(classes.linearProgress, {
        [classes.linearProgressShow]: isLoading,
      })}
    />
  );
};

MyLinearProgress.propTypes = {
  isLoading: PropTypes.bool,
  'data-testid': PropTypes.string,
};

MyLinearProgress.defaultProps = {
  isLoading: false,
  'data-testid': undefined,
};

export default MyLinearProgress;
